import { useState } from "react";
import { Link } from "react-router-dom";
import { SurveyHeader } from "@/components/comiq/SurveyHeader";
import { ChoiceScale } from "@/components/comiq/ChoiceScale";
import { Eyebrow } from "@/components/comiq/Eyebrow";
import { Contour } from "@/components/comiq/Contour";
import { COLORS } from "@/comiq/tokens";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function SurveyQuestion() {
  const [value, setValue] = useState(null);

  return (
    <div className="min-h-screen" style={{ background: COLORS.paper }}>
      <SurveyHeader current={4} total={24} saved />

      <main className="relative overflow-hidden">
        <div className="mx-auto max-w-reading px-5 py-10 sm:py-14 animate-fade-up">
          <Eyebrow>Domain · Commercial DNA</Eyebrow>

          <h1 className="mt-4 text-2xl font-medium sm:text-[1.7rem]" style={{ color: COLORS.ink, lineHeight: 1.3 }}>
            Saya cepat membaca situasi negosiasi dan menyesuaikan pendekatan saya sebelum orang lain menyadarinya.
          </h1>
          <p className="mt-3 text-sm" style={{ color: COLORS.textSoft }}>
            Pilih satu yang paling menggambarkan diri Anda pada umumnya.
          </p>

          <div className="mt-8">
            <ChoiceScale value={value} onChange={setValue} />
          </div>

          {/* Navigation */}
          <div className="mt-10 flex items-center justify-between">
            <Link to="/preview/intro" className="btn-comiq btn-line" data-testid="prev-btn">
              <ArrowLeft size={16} /> Kembali
            </Link>
            <button
              className="btn-comiq btn-accent disabled:opacity-40 disabled:cursor-not-allowed"
              data-testid="next-btn"
              disabled={value === null}
            >
              Lanjut <ArrowRight size={16} />
            </button>
          </div>
        </div>

        {/* Subtle contour, well below the questions */}
        <div className="pointer-events-none flex justify-center pb-6 opacity-70">
          <Contour className="h-24 w-80" tone="ink" />
        </div>
      </main>
    </div>
  );
}
